import { ComponentProps, forwardRef } from 'react';
import TextareaAutosize from 'react-textarea-autosize';

import { cn } from '@frontend/lib/utils';

export interface TitleEditorProps {
  title: string;
  setTitle: (title: string) => void;
}

export const TitleEditor = forwardRef<
  HTMLTextAreaElement,
  TitleEditorProps & ComponentProps<typeof TextareaAutosize>
>(function TitleEditor({ title, setTitle, className, ...textareaProps }, ref) {
  return (
    <TextareaAutosize
      ref={ref}
      placeholder={`Question...`}
      maxRows={10}
      className={cn(
        // Base styles
        'w-full bg-transparent outline-none resize-none overflow-hidden transition-colors',
        'placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50',
        // Default styling (can be overridden)
        'border-0 border-b border-gray-300 rounded-none',
        'text-[15px] font-medium leading-normal tracking-tight text-[#033426]',
        'focus-visible:border-gray-400 focus-visible:ring-0',
        className,
      )}
      onChange={(e) => setTitle(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          e.stopPropagation();
        }
      }}
      value={title}
      {...textareaProps}
    />
  );
});
